import { RealtimeRole } from '@doxyme/og-realtime';
import { createLogger } from 'utility/datadog-util';
import config from '../global/env.config';
const logger = createLogger('OG - RealtimeDebugger', {});
const isDebuggingEnabled = config.IS_REALTIME_DEBUGGER_ENABLED === 'true';
export class RealtimeDebugger {
    constructor() {
        this.patientsWhoLeft = new Set();
    }
    patientJoin(patient) {
        const patientLeft = this.patientsWhoLeft.has(patient.id);
        if (patientLeft && isDebuggingEnabled) {
            logger.error('[RealtimeDebugger] Ghost patient detected', { patient });
        }
    }
    patientLeft(patient) {
        if (patient.role === RealtimeRole.Patient) {
            this.patientsWhoLeft.add(patient.id);
        }
    }
}
